import { render, staticRenderFns } from "./CustomLanguageSelect.vue?vue&type=template&id=481c176c"
import script from "./CustomLanguageSelect.vue?vue&type=script&lang=ts"
export * from "./CustomLanguageSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports